import {
	API_GET_GESLAB_EXPORT,
	API_GET_GESLAB_EXPORT_FAIL,
	API_GET_GESLAB_EXPORT_SUCCESS,
	API_GET_GESLAB_IMPORT,
	API_GET_GESLAB_IMPORT_FAIL,
	API_GET_GESLAB_IMPORT_SUCCESS,
} from 'actions/geslab';
import { toast } from 'react-toastify';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
	loading: false,
};

const geslab = createReducer(initialState, {
	[API_GET_GESLAB_EXPORT]: (state, action) => {
		state.loading = true;
	},
	[API_GET_GESLAB_EXPORT_FAIL]: (state, action) => {
		state.loading = false;
		toast.error(`Le fichier Geslab n'a pas été exporté`);
	},
	[API_GET_GESLAB_EXPORT_SUCCESS]: (state, action) => {
		state.loading = false;
		toast.success(`Le fichier Geslab a été exporté`);
	},
	[API_GET_GESLAB_IMPORT]: (state, action) => {
		state.loading = true;
	},
	[API_GET_GESLAB_IMPORT_FAIL]: (state, action) => {
		state.loading = false;
		toast.error(`Le fichier Geslab n'a pas été importé`);
	},
	[API_GET_GESLAB_IMPORT_SUCCESS]: (state, action) => {
		state.loading = false;
		toast.success(`Le fichier Geslab a été importé`);
	},
});

export default geslab;
